import SupplierList from "../components/supplier/SupplierCrud";

const SuppliersPage = () => {
  return (
    <>
      <SupplierList />
    </>
  );
};

export default SuppliersPage;
